import { render, staticRenderFns } from "./AcceptedHistory.vue?vue&type=template&id=510cacf2&scoped=true&"
import script from "./AcceptedHistory.vue?vue&type=script&lang=js&"
export * from "./AcceptedHistory.vue?vue&type=script&lang=js&"
import style0 from "./AcceptedHistory.vue?vue&type=style&index=0&id=510cacf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510cacf2",
  null
  
)

export default component.exports